import { REACT_APP_BASE_FILE_URL } from "../urls";

export const BACKEND_URL = "";
export const BACKEND_FIles_URL = REACT_APP_BASE_FILE_URL;